import { __makeTemplateObject } from "tslib";
import styled, { css, keyframes } from "styled-components";
import { AnimationType } from "./types";
export var Colorama = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var DEFAULT_COLORS = [
    "#8000ff",
    "#FD0311",
    "#FB8201",
    "#FFF803",
    "#00FF05",
    "#0580FF",
];
var rideRight = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])));
var rideLeft = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])));
var rideTop = keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateY(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateY(-100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var rideBottom = keyframes(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var getRideKeyframes = function (type) {
    if (type === AnimationType.BOTTOM) {
        return rideBottom;
    }
    if (type === AnimationType.LEFT) {
        return rideLeft;
    }
    if (type === AnimationType.RIGHT) {
        return rideRight;
    }
    if (type === AnimationType.TOP) {
        return rideTop;
    }
    return rideLeft;
};
var getAnimationTime = function (type, length) {
    if (length === void 0) { length = 0; }
    if (type === AnimationType.BOTTOM) {
        return 800;
    }
    if (type === AnimationType.LEFT) {
        return length * 80;
    }
    if (type === AnimationType.RIGHT) {
        return length * 95;
    }
    if (type === AnimationType.TOP) {
        return 800;
    }
    return 800;
};
var applyNthChildStyles = function (colorArray, bg) {
    if (colorArray === void 0) { colorArray = DEFAULT_COLORS; }
    if (bg === void 0) { bg = false; }
    var output = colorArray.map(function (color, i) {
        return "\n      &:nth-child(".concat(colorArray.length, "n+").concat(i, ") {\n        color: ").concat(bg ? "#fff" : color, ";\n        background-color: ").concat(bg ? color : "none", ";\n        min-width: ").concat(bg ? "1.5em" : "auto", ";\n        line-height: ").concat(bg ? "1.5em" : "auto", ";\n        text-align: center;\n        display: inline-block;\n      }\n    ");
    });
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), output.join(""));
};
export var Wrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  overflow-x: hidden;\n\n  span.colorama {\n    ", "\n    opacity: 1;\n  }\n"], ["\n  position: relative;\n  overflow-x: hidden;\n\n  span.colorama {\n    ", "\n    opacity: 1;\n  }\n"])), function (props) { return applyNthChildStyles(props.colors || DEFAULT_COLORS, props.bg); });
export var Overflow = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (props) {
    return props.animate && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      animation-direction: ", " !important;\n      animation: ", "\n        ", "ms ease forwards;\n    "], ["\n      animation-direction: ", " !important;\n      animation: ", "\n        ", "ms ease forwards;\n    "])), props.animationDirection, getRideKeyframes(props.animationType), getAnimationTime(props.animationType, props.length));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
